import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { IconPhotosOutline } from '@zillow/constellation';
import { BigDropzone, SmallDropzone } from '@zg-rentals/maintenance-utils';

import { AppSelectors } from '../../selectors';
import { Container } from './StyledComponents';

const propTypes = {
  isSmallDropzone: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isEmpty: PropTypes.bool,
  rootProps: PropTypes.object.isRequired,
  inputProps: PropTypes.object.isRequired,
  displayText: PropTypes.string,
  IconToDisplay: PropTypes.node,
};

const defaultProps = {
  isSmallDropzone: false,
  isDisabled: false,
  isEmpty: false,
  displayText: '',
  IconToDisplay: IconPhotosOutline,
};

const UploadDropzone = ({
  isSmallDropzone,
  isDisabled,
  isEmpty,
  rootProps,
  inputProps,
  displayText,
  IconToDisplay,
}) => {
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  const { isDragAccept } = rootProps;

  const isContainerSizeFixed = (isScreenMobile || isSmallDropzone) && isEmpty;

  return (
    <Container
      isContainerSizeFixed={isContainerSizeFixed}
      isSmallDropzone={isSmallDropzone}
      {...rootProps}
      isDisabled={isDisabled}
    >
      <input {...inputProps} />

      <IconToDisplay size="md" fontColor={isDragAccept && 'brand'} />
      {isScreenMobile || isSmallDropzone ? (
        <SmallDropzone />
      ) : (
        <BigDropzone displayText={displayText} disabled={isDisabled} />
      )}
    </Container>
  );
};

UploadDropzone.propTypes = propTypes;
UploadDropzone.defaultProps = defaultProps;

export default memo(UploadDropzone);
